<app-navbar  style="position: fixed; width: 100%; z-index: 10"></app-navbar>
<!--<app-navbar></app-navbar>-->
<!--<app-navbar1></app-navbar1>-->
<!--<my-copy [getListData]="arr" [totalCards]="this.arr.length" [size]="250"></my-copy>-->
<div style="padding-top: 73px" id="nav">
  <router-outlet >

    <!--  <p>{{'Alobodo'|translate}}</p>-->
    <!--  <p (click)="changeLanguage('fa-ir')">فارسی</p>-->
    <!--  <p  (click)="changeLanguage('en-us')">en</p>-->


  </router-outlet>
</div>



<app-footer></app-footer>

